import { Button, Modal, ProfileCompleteness, User, onProfileCompletenessChange, onUserChange } from '@hub/shared'
import { SqCallout } from '@squidit/react-css'
import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import { SubscriptionLike } from 'rxjs'

const ModalIncompleteProfileComponent = () => {
  const navigate = useNavigate()
  const [t] = useTranslation('modalIncompleteProfile')
  const [openModal, setOpenModal] = useState(false)
  const [user, setUser] = useState<User | null>(null)
  const [loading, setLoading] = useState(true)
  const [profileCompleteness, setProfileCompleteness] = useState<any>(null)
  const onUserChangeSubscription = useRef<SubscriptionLike | undefined>(undefined)
  const onProfileCompletenessChangeSubscription = useRef<SubscriptionLike | undefined>(undefined)
  const [incompletePerfil, setIncompletePerfil] = useState(true)

  useEffect(() => {
    onProfileCompletenessChangeSubscription.current = onProfileCompletenessChange?.subscribe((completeness: ProfileCompleteness) => {
      setProfileCompleteness(completeness)
    })
    onUserChangeSubscription.current = onUserChange?.subscribe((userChanged: User) => {
      setUser({ ...userChanged })
      setLoading(false)
    })

    return () => {
      onProfileCompletenessChangeSubscription?.current?.unsubscribe()
      onUserChangeSubscription?.current?.unsubscribe()
    }
  }, [])

  useEffect(() => {
    if (user?.squidId && profileCompleteness) {
      const incompleteDataProfile =
        (profileCompleteness?.registration?.percentage < 95 && !profileCompleteness?.registration?.detail?.phoneValid) ||
        (profileCompleteness?.registration?.percentage < 100 && profileCompleteness?.registration?.detail?.phoneValid)

      setIncompletePerfil(incompleteDataProfile)
      setOpenModal(incompleteDataProfile)
    }
  }, [user, profileCompleteness])

  return (
    <Modal
      open={openModal}
      buttonClose={false}
      modalSize="sm"
      header={<h5 className="mb-0">{t('modal.title')}</h5>}
      footer={
        <Button onClick={() => navigate('/profile')} size="sm" width="100%">
          {t('modal.buttonText')}
        </Button>
      }
    >
      <SqCallout title={t('modal.warning')}>{t('modal.message')}</SqCallout>
    </Modal>
  )
}

export default ModalIncompleteProfileComponent
